import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getDoneWorksServices(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_SERVICES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICES,
		options
	)
}
function _getDoneWorksServicePreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_SERVICES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICE_PREVIEW,
		options
	)
}
function _getDoneWorksServicePopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_SERVICES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICE_POPUP,
		options
	)
}

function _createDoneWorksService(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_SERVICES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].CREATE_DONE_WORKS_SERVICE,
		options
	)
}

function _getDoneWorksService(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_SERVICES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICE,
		options
	)
}

function _patchDoneWorksService(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_SERVICES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].PATCH_DONE_WORKS_SERVICE,
		options
	)
}

function _putDoneWorksService(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_SERVICES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].PUT_DONE_WORKS_SERVICE,
		options
	)
}

function _deleteDoneWorksService(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_SERVICES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].DELETE_DONE_WORKS_SERVICE,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICES]: _getDoneWorksServices,

	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICE_PREVIEW]: _getDoneWorksServicePreview,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICE_POPUP]: _getDoneWorksServicePopup,

	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].CREATE_DONE_WORKS_SERVICE]: _createDoneWorksService,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICE]: _getDoneWorksService,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].PATCH_DONE_WORKS_SERVICE]: _patchDoneWorksService,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].PUT_DONE_WORKS_SERVICE]: _putDoneWorksService,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].DELETE_DONE_WORKS_SERVICE]: _deleteDoneWorksService,
}